<script>
import AlimentosQuicktable from './Alimentos/quicktable.vue'
export default {
    name: 'Alimentos',
    components: {
        AlimentosQuicktable
    }
}
</script>

|<template>
    <div id="Alimentos">
        <alimentos-quicktable />
    </div>
</template>